<loading-image [is-loading]="isLoading"></loading-image>

<div *ngIf="disableHeader" class="header-div"></div>

<div class="all-content-wrapper">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="header-top-area d-flex justify-content-between align-items-center">
                    <button class="mobile-hamburger" aria-label="Toggle menu" (click)="toggleMobileSidebar()">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <div class="top-menu-left">
                        <span class="welcome-user-info">
                            <span class="welcome-message">{{ 'Welcome' | translate }},</span>
                            <span class="profile-name">
                                <strong>{{ userName }}</strong>
                            </span>
                            <span class="loggedin-user">{{ 'logged in as' | translate }} {{ userId }}</span>
                            <span class="pipe">|</span>
                            <span class="last-login">{{ 'Last Login' | translate }}: </span>
                            <span class="login-day">{{ lastLoginDate }}</span>
                            <span *ngIf="!disableTime" class="login-time">{{ lastLoginTime }}</span>
                        </span>
                    </div>

                    <div class="header-top-menu">
                        <div class="top-menu-right">
                            <ul class="list-inline">
                                <li class="list-inline-item top-menu">
                                    <a href="javascript:void(0)" [routerLink]="['/faq']">{{ 'FAQ' | translate }}</a>
                                </li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item top-menu">
                                    <a href="javascript:void(0)" [routerLink]="['/support']">{{ 'Support' | translate }}</a>
                                </li>
                                <li class="list-inline-item">|</li>
                                <li class="list-inline-item top-menu">
                                    <a href="javascript:void(0)" (click)="onLogoutClick()">{{ 'Logout' | translate }}</a>
                                </li>
                                <li class="list-inline-item">
                                    <div class="bell-icon" (click)="toggleNotificationList($event, op)">
                                        <div *ngIf="hasNewNotifications" class="notification">
                                            <div *ngIf="canViewNotificationsCount" class="count">{{ newNotificationsCount }}</div>
                                        </div>
                                    </div>

                                    <p-dialog label="Top" [appendTo]="'body'" [draggable]="false" [modal]="true" [resizable]="false" [style]="{ width: '30vw' }" [(visible)]="visible">
                                        <p class="m-0">{{ selectedData }}</p>
                                    </p-dialog>
                                </li>
                                <li class="list-inline-item dropdown">
                                    <!-- <a href="javascript:void(0)" class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img class="rounded-circle" src="../../../../assets/images/user.png" alt="user" width="32" height="32">
                  </a> -->
                                    <a id="dropdownMenuButton" class="dropdown-toggle menu-toggle" aria-expanded="false" aria-haspopup="true" aria-label="Menu" data-toggle="dropdown" href="">
                                        <i class="pi pi-bars"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <!--<a class="dropdown-item" href="javascript:void(0)">{{'My Account'|translate}}</a>-->
                                        <a class="dropdown-item" [routerLink]="['/my-profile']">{{ 'My Profile' | translate }}</a>
                                        <a class="dropdown-item" [routerLink]="['/change-password']">{{ 'Settings' | translate }}</a>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="onLogoutClick()">{{ 'Logout' | translate }}</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog #cd header="{{ 'Confirmation' | translate }}" icon="pi pi-exclamation-triangle">
    <p-footer>
        <button type="button" icon="pi pi-times" label="{{ 'No' | translate }}" pButton style="background-color: #1e3a8a; border-color: #1e3a8a" (click)="cd.reject()"></button>
        <button type="button" icon="pi pi-check" label="{{ 'Yes' | translate }}" pButton style="background-color: #1e3a8a; border-color: #1e3a8a" (click)="cd.accept()"></button>
    </p-footer>
</p-confirmDialog>

<p-overlayPanel #op>
    <ng-template pTemplate>
        <div *ngIf="data.length === 0" class="no-notification">
            <p>No Notifications Available</p>
        </div>
        <p-virtualScroller *ngIf="data.length > 0" scrollHeight="560px" [itemSize]="80" [rows]="7" [style]="{ width: '375px' }" [value]="data">
            <ng-template let-item pTemplate="item">
                <div class="notification-container" (click)="viewNotificationDetails(item)">
                    <div class="notificationicon">
                        <img alt="notification" src="../../../../assets/images/icon-notification.svg" />
                    </div>
                    <div class="notification-summary">
                        <h6 class="notification-title">{{ truncateText(item.title, 35) }}</h6>
                        <p class="notification-body">{{ truncateText(item.body, 35) }}</p>
                        <p class="notification-date">{{ item.editedOn | date: 'dd MMM, yyyy h:mm a' }}</p>
                    </div>
                </div>
            </ng-template>
        </p-virtualScroller>
    </ng-template>
</p-overlayPanel>
